module.exports = __webpack_public_path__ + "static/media/apartment2a.bc219dff.jpg";